import { isTenantAdmin, useTenantStore } from '@/auth/tenantStore';

/**
 * True when the current user may perform destructive contact actions (delete,
 * bulk delete, delete-import) — i.e. they hold the admin or super-admin client role.
 * The backend independently enforces the `TenantAdmin` policy on those routes;
 * this only governs whether the UI is shown.
 */
export function useCanManageContacts(): boolean {
  return useTenantStore(isTenantAdmin);
}
